(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hdc-accordeons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hdc-accordion')) {
  class HdcAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.hdc-acc__trigger').forEach((btn) => {
        btn.addEventListener('click', () => this.toggle(btn));
      });
    }
    toggle(btn) {
      const item = btn.closest('.hdc-acc__item');
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!item || !panel) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (btn.getAttribute('aria-expanded') !== 'true') {
        panel.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => requestAnimationFrame(() => item.classList.add('is-open')));
        return;
      }
      btn.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      if (reduced) {
        panel.hidden = true;
        return;
      }
      const done = (e) => {
        if (e && e.target !== panel) return;
        panel.removeEventListener('transitionend', done);
        clearTimeout(timer);
        if (btn.getAttribute('aria-expanded') === 'false') panel.hidden = true;
      };
      const timer = setTimeout(done, 450);
      panel.addEventListener('transitionend', done);
    }
  }
  customElements.define('hdc-accordion', HdcAccordion);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hdc-titre"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('[data-hdc-avis]');
  if (!link) return;
  var target = document.querySelector('.hbr');
  if (!target) return;
  e.preventDefault();
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
});
  } catch(e) { console.error(e); }
})();

})();
